import { sylvanus } from '~/services/serviceInstances';

import {
  type DdeTable,
  mapDdeTable,
  type ServerDdeTableResponse,
} from './ddeTableTypes';

type GetDdeTableRequest = {
  tableId: string;
};

export const getDdeTable = async ({
  tableId,
}: GetDdeTableRequest): Promise<DdeTable> => {
  const response = await sylvanus.get<ServerDdeTableResponse>(
    `/dde/table/${tableId}`,
  );

  return mapDdeTable(response);
};
